import React, { useState, useEffect, useCallback } from 'react';
import './Hero.css';


const SLIDES = [
  {
    eyebrow: 'N i k e',
    line1: 'AIR FORCE 1',
    body: 'Elevate your everyday with a timeless icon. At SA Dropped, we believe the best stories are written in the classics—starting with the shoes on your feet.',
    img: '/images/AF1.png',
    num: '01',
    vertical: '07 - TRIPLE WHITE',
  },
  {
    eyebrow: 'N i k e',
    line1: 'JORDAN "BRED"',
    body: 'Own the defiance. At SA Dropped, we celebrate the Air Jordan 1 "Bred" (Black and Red)—the legendary silhouette that was famously “banned” by the NBA and went on to spark the modern sneaker revolution.',
    img: '/images/JD1.png',
    num: '02',
    vertical: 'THE "BRED" LEGACY',
  },
  {
    eyebrow: 'N i k e',
    line1: 'DUNK LOW',
    body: 'Elevate your rotation with the ultimate versatile essential. At SA Dropped, we bring you the Nike Dunk Low "Panda"—the black and white icon that effortlessly bridges the gap between 80s basketball heritage and modern street style.',
    img: '/images/NDLOW.png',
    num: '03',
    vertical: 'THE MODERN CLASSIC',
  },
  {
    eyebrow: 'N i k e',
    line1: 'AIR JORDAN 4 ',
    body: 'Timeless design language reimagined for the modern era. Icons never fade — they evolve with you.',
    img: '/images/AJ4.png',
    num: '04',
    vertical: '"IMPERIAL PURPLE"',
  },
];

export default function Hero() {
  const [cur, setCur] = useState(0);
  const [fading, setFading] = useState(false);

  const go = useCallback((dir) => {
    if (fading) return;
    setFading(true);
    setTimeout(() => {
      setCur(prev => (prev + dir + SLIDES.length) % SLIDES.length);
      setFading(false);
    }, 500);
  }, [fading]);

  useEffect(() => {
    const timer = setInterval(() => {
      go(1);
    }, 5000);
    return () => clearInterval(timer);
  }, [go]);

  const s = SLIDES[cur];

  return (
    <main className="hero-container">
      <div className={`hero__bg-text ${fading ? 'fade' : ''}`}>{s.num}</div>

      <section className={`hero-content ${fading ? 'fade' : ''}`}>
        <div className="hero__left">
          <p className="hero__eyebrow">{s.eyebrow}</p>
          <h1 className="hero__title">{s.line1}</h1>
          <p className="hero__description">{s.body}</p>
        </div>

        <div className="hero__right">
          <div className="visual-container">
            <div className="visual-inner">
              <div className="grass-platform"></div>
              <img src={s.img} alt="Shoe" className="hero__main-image" />
            </div>
          </div>

          <div className="vertical-branding">
            <span className="v-text">{s.vertical}</span>
          </div>
        </div>
      </section>

      <nav className="hero__nav-controls">
        <button onClick={() => go(-1)} className="nav-arrow">PREV</button>
        <div className="nav-line">
          <div className="nav-line-progress" style={{ width: `${((cur + 1) / SLIDES.length) * 100}%` }}></div>
        </div>
        <button onClick={() => go(1)} className="nav-arrow">NEXT</button>
      </nav>
    </main>
  );
}